//Takes text formatted like 'THIS_IS_AN_EXAMPLE' and turns it into 'This Is An Example'
export function parseSnakeCaseToHumanReadable(input: string): string {
  const words = input.split('_');
  for (let i = 0; i < words.length; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].substring(1).toLowerCase();
  }
  return words.join(' ');
}

//Converts hex string to text
export function HexToText(hexString) {
  let text = '';
  for (let i = 0; i < hexString.length; i += 2) {
    const hexByte = hexString.substring(i, i + 2);
    const decimalValue = parseInt(hexByte, 16);
    text += String.fromCharCode(decimalValue);
  }
  return text;
}

//Converts text to hex string
export function TextToHex(text) {
  let hexString = '';
  for (let i = 0; i < text.length; i++) {
    const hexByte = text.charCodeAt(i).toString(16);
    hexString += hexByte;
  }
  return hexString;
}
